import { useSelector } from "react-redux";
import { getIsLockerShop, getIsPricelessShop } from "@selectors/store";

import CartListingLocker from "@components/store/cart/cart-listing-locker";
import CartListingSendToMany from "@components/store/cart/send-to-many-cart-listing";

const Cart = ({ cmsSectionIndex = 0 }) => {
  const isLockerShop = useSelector(getIsLockerShop);
  const isPricelessShop = useSelector(getIsPricelessShop);

  return isLockerShop || isPricelessShop ? (
    <CartListingLocker cmsSectionIndex={cmsSectionIndex} />
  ) : (
    <CartListingSendToMany cmsSectionIndex={cmsSectionIndex} />
  );
};
export default Cart;
